
export default {
  data() {
    return {
      config: {},
      value: "",
      configs: [
        {
          value: "fixed-value",
          text: "Fixed Value",
          icon: "mdi-currency-rupee"
        },
        {
          value: "increment-amount",
          text: "Increment Amount",
          icon: "mdi-currency-rupee"
        },
        {
          value: "decrement-amount",
          text: "Decrement Amount",
          icon: "mdi-currency-rupee"
        },
        {
          value: "increment-percentage",
          text: "Increment Percentage",
          icon: "mdi-percent"
        },
        {
          value: "decrement-percentage",
          text: "Decrement Percentage",
          icon: "mdi-percent"
        }
      ]
    };
  },
  methods: {
    valueChange() {
      this.$emit("valueChange", {
        config: this.config?.value,
        value: this.value
      });
    }
  }
};
